module.exports = __webpack_public_path__ + "img/Logo_8_march.svg";